module.exports = __webpack_public_path__ + "img/vendor-icon-eventdecorator.ac785b2c.png";